import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CoreModule } from 'src/app/core/core.module';
import { ExampleRoutingModule } from './dashboards-routing.module';
import { DashboardsComponent } from './dashboards.component';
import { PreparationTasksComponent } from './masters/preparation-tasks/preparation-tasks.component';

@NgModule({
  declarations: [DashboardsComponent],
  imports: [
    CommonModule,
    ExampleRoutingModule,
    CoreModule
  ]
})
export class DashboardsModule { }
